export enum ProfileType {
    COORDINATOR = 'COORDINATOR',
    TEAM_LEADER = 'TEAM_LEADER',
}
